import React, { useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { faEdit, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Components
import TextField from '../../../../../components/TextField';

//Helpers
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../../helpers/message';

//Context
import { useAuth } from '../../../../../context/auth';

//API
import perfil_api from '../../../../../api/perfil_api';

function Identificacao({ perfil, setPerfil, loadPerfilItem, editavel }) {
    //Estado de controle dos erros nos campos
    const [errors, setErrors] = useState({});

    const { setLoading } = useAuth();

    //Função de onChange dos campos
    const onChange = (e) => {
        const { name, value } = e.target;
        setPerfil({
            ...perfil,
            [name]: value
        })
    }

    //Campos obrigatorios
    const camposIdentificacao = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "tipo", required: true })
    ]

    //Função que salva o perfil
    const salvarPerfil = () => {
        const _errors = validarCampos(perfil, camposIdentificacao);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _perfil = { ...perfil };

        if (_perfil.id) {
            setLoading(true);
            perfil_api.put(_perfil).then(response => {
                showMessage("Aviso", "Dados de identificacao do Perfil Atualizados com Sucesso!", "success", () => loadPerfilItem());
            })
                .catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            setLoading(true);
            perfil_api.post(_perfil).then(response => {
                showMessage("Aviso", "Dados de identificação do perfil criados com Sucesso!", "success", () => loadPerfilItem(response.data));
            })
                .catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        }

        return false;
    }

    return <>
        <Row>
            <h5 className='mb-3'>Identificação do Perfil</h5>
            <Col md="12" lg="4">
                <TextField
                    name={"identificacao"}
                    label={"* Identificação"}
                    value={perfil.identificacao}
                    invalid={!!errors.identificacao}
                    maxLength={100}
                    onChange={onChange}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="4">
                <TextField
                    type={"select"}
                    label="* Tipo"
                    name={"tipo"}
                    options={
                        [
                            { label: "Gestor", value: "Gestor" },
                            { value: "Fiscal", label: "Fiscal" }
                        ]
                    }
                    onChange={onChange}
                    value={perfil.tipo}
                    invalid={!!errors.tipo}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="4">
                <TextField
                    type={"radio"}
                    label="* Status"
                    name={"status"}
                    options={
                        [
                            { label: "Ativo", value: "Ativo" },
                            { value: "Inativo", label: "Inativo" }
                        ]
                    }
                    onChange={onChange}
                    value={perfil.status}
                    invalid={!!errors.status}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="4">
                <TextField
                    type={"radio"}
                    label="* Acessa o APP"
                    name={"acessaAPP"}
                    options={
                        [
                            { label: "Ativo", value: "true" },
                            { label: "Inativo", value: "false" }
                        ]
                    }
                    onChange={onChange}
                    value={perfil.acessaAPP}
                    invalid={!!errors.acessaAPP}
                    disabled={!editavel}
                />
            </Col>
            <Col md="12" lg="12" className='d-flex align-items-center justify-content-center '>
                {editavel &&
                    <Button
                        color={perfil.id ? 'warning text-white' : 'success'}
                        className='px-4'
                        onClick={salvarPerfil}>
                        {perfil.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : <><FontAwesomeIcon icon={faSave} /> Salvar</>}
                    </Button>
                }
            </Col>
        </Row>
    </>;
}

export default Identificacao;